<template>
  <div id="question-list" v-loading="getLoading">
    <div class="question-list">
      <div class="question-tab">
        <div class="hot-tab" v-click-type-outside="onClickOutside" :class="{'hot-tab-active': !label}" @click="$emit('showQuestionType')">热门问题</div>
        <div class="feedback-tab" @click="$emit('feedback')" :class="{'feedback-tab-active': label}">
          我的反馈<red-point></red-point>
        </div>
      </div>
      <section>
        <question-type class="ques-label" v-if="isSelectType" @changeQuestionType="changeQuestionType" :typeId="typeId"></question-type>
      </section>
      <div class="mask-wrap" :class="[isSelectType ? 'mask-scroll-none' : '']">
        <div class="mask" v-show="isSelectType"></div>
        <div class="question-item"
             :class="[item.unreadMessageCount !== 0 && item.unreadMessageCount !== undefined && label && !item.isGetUnread ? 'red-point-item' : '', isSelectQuizId === item.id ? 'select-question' : '']"
             v-for="item in getQuestionPage"
             :key="item.id"
             @click="$emit('getQuestionDetail', item.id)">
          <div class="question-title">{{ item.topic }}</div>
          <div class="question-aside" v-if="!label">
            <div class="read">{{ item.readCount }}</div>
            <!-- 如果有新评论，则自动加 1 -->
            <div class="comment" v-if="item.isAddMessage">{{ item.messageCount + item.isAddMessage }}</div>
            <div class="comment" v-else>{{ item.messageCount }}</div>
          </div>
          <div class="question-aside question-aside-feedback" v-else>
            <div class="time">{{ item.createdTime | getCreatedTime }} 提问</div>
            <!-- tab 切换的过程中 isAt 为 undefined，为了避免切换过程中全部出现红点，必须要判断是否为 undefined -->
            <div class="comment"
                 v-if="item.isAt === 0 && item.isAt !== undefined"
                 :class="[(item.unreadMessageCount !== 0 && item.unreadMessageCount !== undefined && !item.isGetUnread) ? 'red-comment' : '']">
              {{ item | addMessageCount }}
            </div>
            <div class="comment"
                 :class="{'red-comment': !item.isGetUnread}"
                 v-if="item.isAt === 1 && item.isAt !== undefined">@</div>
          </div>
        </div>
        <div class="mar-bottom"></div>
      </div>
    </div>
    <div class="question-pagination">
      <pagination v-if="getAllQuestionCount" background layout="prev, pager, next"
                  :total="getAllQuestionCount"
                  :pageSize="getPageSize"
                  :pagerCount="getMaxPageCount"
                  :currentPage.sync="currentPage"
                  @current-change="getPage"></pagination>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import questionType from '../questionType/question-type'
import questionPagination from '../question-pagination/question-pagination'
import redPoint from '../red-point/red-point'
import {Pagination} from 'element-ui'

export default {
  name: 'question-list',
  props: {
    label: Number,
    isSelectType: Boolean,
    isSelectQuizId: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      typeId: -1,
      redPoint: this.getRedPoint,
      currentPage: 1
    }
  },
  computed: {
    ...mapGetters([
      'getQuestionPage',
      'getRedPoint',
      'getPageCount',
      'getPageSize',
      'getAllQuestionCount',
      'getMaxPageCount',
      'getQuestionDetail',
      'getLoading'
    ])
  },
  components: {
    questionType,
    questionPagination,
    redPoint,
    Pagination
  },
  methods: {
    ...mapActions([
      'action_getHotQuestionPage',
      'action_getClassifyQuestionPage',
      'action_getUserQuestionPage',
      'setQuestionPage',
      'setAllQuestionCount',
      'setLoading'
    ]),
    changeQuestionType (typeId) {
      this.typeId = typeId
      this.$emit('changeQuestionType', typeId)
    },
    getPage (val) {
      // 参数val代表当前所在页，起始值为1
      let params = null
      this.setLoading(true)
      if (this.label === 0) {
        if (this.typeId === -1) {
          params = {
            currentPage: val - 1,
            pageSize: this.getPageSize
          }
          this.action_getHotQuestionPage(params).then(res => {
            this.setLoading(false)
            if (res.erpCode === '000') {
              this.setQuestionPage(res.erpData.pageItem)
              this.setAllQuestionCount(res.erpData.totalCount)
            } else {
              this.$message({
                showClose: true,
                message: res.erpMsg || '您还未选择评级',
                type: 'warning'
              })
            }
          })
        } else {
          params = {
            type: this.typeId,
            currentPage: val - 1,
            pageSize: this.getPageSize
          }
          this.action_getClassifyQuestionPage(params).then(res => {
            this.setLoading(false)
            if (res.erpCode === '000') {
              this.setQuestionPage(res.erpData.pageItem)
              this.setAllQuestionCount(res.erpData.totalCount)
            } else {
              this.showMessage(res.erpMsg || '获取问题列表出错')
            }
          })
        }
      } else {
        params = {
          currentPage: val - 1,
          pageSize: this.getPageSize
        }
        this.action_getUserQuestionPage(params).then(res => {
          this.setLoading(false)
          if (res.erpCode === '000') {
            this.setQuestionPage(res.erpData.pageItem)
            this.setAllQuestionCount(res.erpData.totalCount)
          } else {
            this.showMessage(res.erpMsg || '获取问题列表出错')
          }
        })
      }
    },
    onClickOutside () {
      this.$emit('closeQuestionType')
    }
  },
  directives: {
    clickTypeOutside: {
      bind: function (el, {value}) {
        let onClickOutside = value
        el.handler = function (e) {
          let questionTypeNode
          if (document.getElementsByTagName('section')[0] && document.getElementsByTagName('section')[0].getElementsByClassName('wrap')[0]) {
            questionTypeNode = document.getElementsByTagName('section')[0].getElementsByClassName('wrap')[0]
            if (el && !el.contains(e.target) && !questionTypeNode.contains(e.target)) {
              onClickOutside(e)
            }
          } else {
            if (el && !el.contains(e.target)) {
              onClickOutside(e)
            }
          }
        }
        document.addEventListener('click', el.handler, true)
      },
      unbind: function (el) {
        document.removeEventListener('click', el.handler, true)
        el.handler = null
      }
    }
  },
  filters: {
    addMessageCount (item) {
      let count = item.unreadMessageCount ? item.unreadMessageCount : item.messageCount
      let add = item.isAddMessage ? item.isAddMessage : ''
      return count + add
    },
    getCreatedTime (value) {
      if (value !== undefined) {
        let day = '周' + '日一二三四五六'.charAt(new Date(value.substr(0, 10).replace(/\-/g, "\/")).getDay())
        return value.substr(0, 10).replace(/\-/g, "\/") + ' ' + day + value.substr(10)
      }
    }
  },
  watch: {
    label (val) {
      this.currentPage = 1
    },
    typeId (val) {
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
  #question-list {
    display: flex;
    flex-direction: column;
    position: relative;
    /*width: 375px;*/
    width: calc(31% - 8px);
  }

  /* 问题列表 */
  .question-list {
    flex: 1;
    position: relative;
    /*width: 377px;*/
    width: 100%;
  }

  .question-tab {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 2px;
    background: #fff;
  }

  .hot-tab, .feedback-tab {
    position: relative;
    height: 40px;
    padding: 0 10px;
    line-height: 40px;
    font-size: 14px;
    color: #333333;
    font-family: PingFangSC-Regular, 'microsoft yahei', sans-serif;
    cursor: pointer;
  }
  .hot-tab-active {
    color: #4A90E2;
    background: #fff url("../../icons/down-arrow-blue.svg") no-repeat right 17px;
  }
  .feedback-tab-active {
    color: #4A90E2;
  }
  .hot-tab-active:after, .feedback-tab-active:after {
    content: "";
    display: block;
    width: 55px;
    height: 2px;
    background: #4A90E2;
  }
  .ques-label {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 42px;
    z-index: 99;
  }
  .mask-wrap {
    position: absolute;
    left: 0;
    top: 42px;
    width: 100%;
    height: 100%;
    overflow: scroll;
    background: #fff;
  }
  .mask-wrap::-webkit-scrollbar {
     width: 4px;
   }
  .mask-wrap::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  .mask-wrap:hover::-webkit-scrollbar-thumb {
    background-color: #ccc;
  }

  .mask-scroll-none {
    overflow: hidden;
  }
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background: #333;
    opacity: 0.4;
    z-index: 1;
  }
  .question-item {
    position: relative;
    /*width: 375px;*/
    width: 100%;
    height: 68px;
    border-bottom: 1px solid #E2E2E2;
    background: #fff;
    cursor: pointer;
  }
  .select-question {
    background: #ecf3fc;
  }
  .red-point-item::after {
    content: "";
    position: absolute;
    left: 15px;
    top: 17px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fe3824;
  }
  .mar-bottom {
    height: 75px;
  }

  .question-title {
    height: 20px;
    padding: 12px 12px 0 28px;
    font-size: 15px;
    line-height: 20px;
    color: #030303;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .question-aside {
    display: flex;
    height: 18px;
    padding: 10px 0 8px 28px;
    font-size: 13px;
    line-height: 18px;
    color: #B7B7B7;
  }

  .time {}
  .read {
    box-sizing: border-box;
    width: 62px;
    padding-left: 18px;
    background: url("../../icons/viewed.svg") no-repeat 0 4px;
  }

  .comment {
    box-sizing: border-box;
    width: 50px;
    padding-left: 16px;
    background: url("../../icons/comment.svg") no-repeat 0 3px;
  }
  .red-comment {
    color: #fe3824;
    background: url("../../icons/image/redcomment.png") no-repeat 0 3px;
  }

  .like {
    padding-left: 15px;
    background: url("../../icons/little-finger.svg") no-repeat 0 2px;
  }
  .question-aside-feedback {
    justify-content: space-between;
  }
  .question-pagination {
    position: absolute;
    left: 50%;
    bottom: 6px;
    text-align: center;
    transform: translate(-50%, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components/question-list/question-list.vue